import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/Home.vue')
  },
  {
    path: '/welcome',
    name: 'welcome',
    component: () => import('../views/Welcome.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../components/Login.vue')
  },
  /*{
    path: '/signup',
    name: 'signup',
    component: () => import('../components/Signup.vue')
  },*/
  {
    path: '/users/reset_pwd',
    name: 'reset_pwd',
    component: () => import('../components/users/ResetPwd.vue')
  },
  {
    path: '/users/edit_privacy',
    name: 'edit_privacy',
    component: () => import('../components/users/PrivacyEdit.vue')
  },
  {
    path: '/users/profile',
    name: 'user_profile',
    component: () => import('../components/users/UserProfile.vue')
  },
  {
    path: '/subs/add',
    name: 'add_subs',
    component: () => import('../components/subs/SubsCreate.vue')
  },
  {
    path: '/subs/ok',
    name: 'subs_ok',
    component: () => import('../components/subs/SubsOk.vue')
  },
  {
    path: '/subs/ko',
    name: 'subs_ko',
    component: () => import('../components/subs/SubsKo.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router